import { render } from "./OldWallView.vue?vue&type=template&id=d1f4cdac&scoped=true"
import script from "./OldWallView.vue?vue&type=script&lang=js"
export * from "./OldWallView.vue?vue&type=script&lang=js"

import "./OldWallView.vue?vue&type=style&index=0&id=d1f4cdac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1f4cdac"]])

export default __exports__